import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IconDocumentLines from '../../../../../../../common/icons/document-lines.svg';
import IconDocument from '../../../../../../../common/icons/document.svg';
import IconDOC from '../../../../../../../common/icons/doc.svg';
import IconJPG from '../../../../../../../common/icons/jpg.svg';
import IconPDF from '../../../../../../../common/icons/pdf.svg';
import IconPNG from '../../../../../../../common/icons/png.svg';
import IconPPT from '../../../../../../../common/icons/ppt.svg';
import IconRTF from '../../../../../../../common/icons/rtf.svg';
import IconTIF from '../../../../../../../common/icons/tiff.svg';
import IconTXT from '../../../../../../../common/icons/txt.svg';
import IconXLS from '../../../../../../../common/icons/xls.svg';
// import CircularProgressbar from 'react-circular-progressbar';
import Loader from 'react-loader-spinner';
import './style.scss';

class AttachmentMessage extends React.Component {
    constructor(props) {
        super(props);

        this.API = this.props.API;

        this.downloadFile = this.downloadFile.bind(this);
    }

    downloadFile(e) {
        e.preventDefault();

        this.API.Helper.downloadFile(this.props.data['file-id']);
    }

    renderDocumentIcon(name) {
        const ext = name.substring(name.lastIndexOf('.'));
        switch(ext) {
            case '.doc': return (<IconDOC />);
            case '.docx': return (<IconDOC />);
            case '.jpg': return (<IconJPG />);
            case '.jpeg': return (<IconJPG />);
            case '.pdf': return (<IconPDF />);
            case '.png': return (<IconPNG />);
            case '.ppt': return (<IconPPT />);
            case '.pptx': return (<IconPPT />);
            case '.rtf': return (<IconRTF />);
            case '.tif': return (<IconTIF />);
            case '.tiff': return (<IconTIF />);
            case '.txt': return (<IconTXT />);
            case '.xls': return (<IconXLS />);
            case '.xlsx': return (<IconXLS />);
            default: return (<IconDocumentLines />);
        }
    }

    renderDownloadMessage() {
        const { message, data } = this.props;
        const icon = this.renderDocumentIcon(data['file-name']);
        if(this.props.storageDisabled || this.props.disabled) {
            return (
                <React.Fragment>
                    <div className="message-container-attachment--icon">{icon}</div>
                    <div className="message-container-attachment--text" title="Plik niedostępny z powodu wykorzystanego limit pobrań" style={{textDecoration: 'line-through'}}><p>{message}</p></div>
                </React.Fragment>
            );
        }
        else {
            return (
                <React.Fragment>
                    <div className="message-container-attachment--icon">{icon}</div>
                    <div className="message-container-attachment--text"><p><a onClick={this.downloadFile}>{message}</a></p></div>
                </React.Fragment>
            );
        }
    }

    render() {
        const { message, progress} = this.props;
        return (
            <div
                className="message-container message-container-attachment"
                onClick={this.props.onClick}
            >
                {progress !== null ? (
                    <React.Fragment>
                        {/* {progress >= 0 && (<div className="message-container-attachment--progress" title={`Wysłano ${progress}%`}><CircularProgressbar percentage={progress} /></div>)} */}
                        {progress >= 0 && (<div className="message-container-attachment--progress" title="Wysyłam"><Loader type="Oval" color="#fff" width="40" height="40" /></div>)}
                        {progress < 0 && (<div className="message-container-attachment--icon" title="Błąd transmisji pliku"><IconDocument /></div>)}
                        <div className="message-container-attachment--text"><p>{message}</p></div>
                    </React.Fragment>
                ) : this.renderDownloadMessage()}
            </div>
        );
    }
}

AttachmentMessage.defaultProps = {
    message: '',
    customMessage: {},
    disabled: false
};

AttachmentMessage.propTypes = {
    message: PropTypes.string.isRequired,
    customMessage: PropTypes.object.isRequired,
    progress: PropTypes.number,
    disabled: PropTypes.bool
};

const isStorageLimitsExceeded = (limits) => {
    const maxDownloads = parseInt(limits['download-attempts']);
    const usedDownloads = parseInt(limits['used-download-attempts']);
    return usedDownloads >= maxDownloads;
};

const mapStateToProps = state => {
    return {
        storageDisabled: isStorageLimitsExceeded(state.chat.fileLimits)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentMessage);
